import { IconCheckmarkSmallOutline, IconMinusSmallOutline } from '@teamleader/ui-icons';
import cx from 'classnames';
import React, { ReactNode, useCallback, MouseEvent } from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

export interface CheckboxProps extends BoxProps {
  checked?: boolean;
  onChange?: (checked: boolean, event: MouseEvent<HTMLInputElement>) => void;
  name?: string;
  label?: ReactNode;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({ className, checked, onChange, name, label, disabled, ...rest }) => {
  const handleToggle = useCallback(
    (event: MouseEvent<HTMLInputElement>) => {
      onChange && onChange(!checked, event);
    },
    [onChange, checked],
  );

  const classNames = cx(
    styles['checkbox'],
    {
      [styles['is-checked']]: checked,
      [styles['is-disabled']]: disabled,
    },
    className,
  );

  return (
    <Box element="label" data-teamleader-ui="checkbox" className={classNames} {...rest}>
      <input
        className={styles['input']}
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        onClick={handleToggle}
        readOnly
      />
      <span className={styles['shape']}>
        {checked ? (
          <IconCheckmarkSmallOutline className={styles['icon']} />
        ) : (
          <IconMinusSmallOutline className={styles['icon']} />
        )}
      </span>
      {label && (
        <span className={styles['label']}>
          <Box element="span" color={disabled ? 'neutral' : 'teal'}>
            {label}
          </Box>
        </span>
      )}
    </Box>
  );
};

export default Checkbox;
